function phoneDigits(value: unknown): string {
  return typeof value === "string" ? value.replace(/[^\d+]/g, "") : "";
}

function escapeVCardValue(value: string): string {
  return value
    .replaceAll("\\", "\\\\")
    .replaceAll("\n", "\\n")
    .replaceAll(";", "\\;")
    .replaceAll(",", "\\,");
}

export function vCardQrContent(value: unknown): string {
  if (!value || typeof value !== "object") return "";
  const contact = value as {
    fullName?: unknown;
    organization?: unknown;
    title?: unknown;
    phone?: unknown;
    email?: unknown;
    website?: unknown;
  };
  const text = (candidate: unknown): string =>
    typeof candidate === "string" ? candidate.trim() : "";
  const fullName = text(contact.fullName);
  if (!fullName) return "";
  const lines = ["BEGIN:VCARD", "VERSION:3.0", `FN:${escapeVCardValue(fullName)}`];
  const organization = text(contact.organization);
  const title = text(contact.title);
  const phone = phoneDigits(contact.phone);
  const email = text(contact.email);
  const website = text(contact.website);
  if (organization) lines.push(`ORG:${escapeVCardValue(organization)}`);
  if (title) lines.push(`TITLE:${escapeVCardValue(title)}`);
  if (phone) lines.push(`TEL;TYPE=CELL:${phone}`);
  if (email) lines.push(`EMAIL:${escapeVCardValue(email)}`);
  if (website) lines.push(`URL:${escapeVCardValue(website)}`);
  lines.push("END:VCARD");
  return lines.join("\r\n");
}
